import React from 'react';
import { NotificationItemProps } from './types';

export function NotificationItem({ notification, onClick, onMarkAsRead, formattedDescription }: NotificationItemProps) {
  const handleClick = () => {
    if (!notification.is_read) {
      onMarkAsRead();
    }
    onClick();
  };

  const formatDateTime = (dateString: string) => {
    const date = new Date(dateString);
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);
    
    const notificationDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    
    if (notificationDate.getTime() === today.getTime()) {
      // Today - show time
      return date.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      });
    } else if (notificationDate.getTime() === yesterday.getTime()) {
      // Yesterday
      return 'Yesterday';
    } else {
      // Older - show date
      return date.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric'
      });
    }
  };

  const truncateText = (text: string, maxLength: number = 60) => {
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
  };

  return (
    <div 
      className="flex items-center justify-between py-3 px-4 hover:bg-gray-50 cursor-pointer border-b border-gray-100 last:border-b-0"
      onClick={handleClick}
    >
      {/* Unread indicator */}
      {!notification.is_read && (
        <div className="w-2 h-2 bg-blue-500 rounded-full mr-3 flex-shrink-0" />
      )}
      
      {/* Content */}
      <div className="flex-1 min-w-0 pr-3">
        <p className={`text-sm truncate ${!notification.is_read ? 'font-medium text-gray-900' : 'text-gray-700'}`}>
          {truncateText(formattedDescription || notification.description)}
        </p>
      </div>
      
      {/* Time/Date */}
      <div className="flex-shrink-0">
        <p className="text-xs text-gray-500">
          {formatDateTime(notification.created_at)}
        </p>
      </div>
    </div>
  );
}
